/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntityUser } from '../../models/entity-user';

export interface ApiKeycloakGetUsersGet$Plain$Params {
  skip?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  Authorization?: string;
}

export function apiKeycloakGetUsersGet$Plain(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetUsersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EntityUser>>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetUsersGet$Plain.PATH, 'get');
  if (params) {
    rb.query('skip', params.skip, {});
    rb.query('email', params.email, {});
    rb.query('firstName', params.firstName, {});
    rb.query('lastName', params.lastName, {});
    rb.query('username', params.username, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EntityUser>>;
    })
  );
}

apiKeycloakGetUsersGet$Plain.PATH = '/api/keycloak/GetUsers';
